export const UI_COLOR_WHITE = '#FFFFFF'
export const UI_COLOR_BLACK = '#000000'
export const UI_COLOR_BLACK_ALPHA_12 = 'rgba(0,0,0,0.12)'
export const UI_COLOR_BLACK_ALPHA_26 = 'rgba(0,0,0,0.26)'
export const UI_COLOR_BLACK_ALPHA_38 = '#00000061'
export const UI_COLOR_BLACK_ALPHA_40 = '#00000066'
export const UI_COLOR_BLACK_ALPHA_60 = '#00000099'
export const UI_COLOR_TRANSPARENT = 'transparent'

// Secondary Colors
export const UI_COLOR_SECONDARY_MAIN = '#27588D'
export const UI_COLOR_SECONDARY_DARK = '#4672A3'
export const UI_COLOR_SECONDARY_MID = '#597FA9'
export const UI_COLOR_SECONDARY_LIGHT = '#93A7C5'
export const UI_COLOR_SECONDARY_LIGHTER = '#C7D3EB'

// Primary Colors
export const UI_COLOR_PRIMARY_DEFAULT = '#FF893D'
export const UI_COLOR_PRIMARY_HOVER_ORANGE = '#F1762B'
export const UI_COLOR_PRIMARY_PRESSED = '#E6752E'
export const UI_COLOR_PRIMARY_SELECT = '#FFD4A8'
export const UI_COLOR_PRIMARY_LIGHT_BG = '#FFF1E6'

// Brand palette for primary actions, links, and emphasis states.
export const UI_COLOR_PRIMARY = UI_COLOR_SECONDARY_MID
export const UI_COLOR_SECONDARY = UI_COLOR_SECONDARY_MAIN
export const UI_COLOR_BRAND_NAVY = UI_COLOR_SECONDARY_MAIN

export const UI_COLOR_PRIMARY_ALT = '#50739A'
export const UI_COLOR_PRIMARY_HOVER = '#4A6D93'
export const UI_COLOR_PRIMARY_ALT_HOVER = '#4F7096'
export const UI_COLOR_PRIMARY_EMPHASIS = '#4B6EA9'
export const UI_COLOR_PRIMARY_SOFT = 'rgba(89, 127, 169, 0.1)'
export const UI_COLOR_PRIMARY_SOFT_BORDER = 'rgba(89, 127, 169, 0.5)'
export const UI_COLOR_PRIMARY_BADGE_SHADOW = '0 4px 10px rgba(89, 127, 169, 0.28)'
export const UI_COLOR_PRIMARY_LINK = '#337AB7'
export const UI_COLOR_USER_AVATAR_ICON = UI_COLOR_SECONDARY_MAIN
export const UI_COLOR_ACCENT_ORANGE = UI_COLOR_PRIMARY_DEFAULT
export const UI_COLOR_ACCENT_ORANGE_TEXT = UI_COLOR_PRIMARY_HOVER_ORANGE
export const UI_COLOR_ACCENT_ORANGE_SOFT = '#FF8A3D'
export const UI_COLOR_ACCENT_ORANGE_BRIGHT = '#FF9138'
export const UI_COLOR_ACCENT_ORANGE_ALT = '#F47B2A'
export const UI_COLOR_ACCENT_ORANGE_HOVER = '#D9681D'
export const UI_COLOR_ACCENT_ORANGE_ALT_HOVER = '#FF7C29'
export const UI_COLOR_GRADIENT_PRIMARY_TO_WHITE = `linear-gradient(90deg, ${UI_COLOR_PRIMARY_DEFAULT} 0%, ${UI_COLOR_WHITE} 100%)`
export const UI_COLOR_GRADIENT_SECONDARY_TO_WHITE = `linear-gradient(90deg, ${UI_COLOR_SECONDARY_MAIN} 0%, ${UI_COLOR_WHITE} 100%)`

// Semantic feedback colors for success and error states across modules.
export const UI_COLOR_SUCCESS = '#2E7D32'
// Alternate success tone used in financial balance/difference indicators.
export const UI_COLOR_SUCCESS_ALT = '#27AE60'
export const UI_COLOR_SUCCESS_TEXT = '#2E7D32'
export const UI_COLOR_SUCCESS_SOFT = '#EAF6EB'
export const UI_COLOR_SUCCESS_BORDER = '#A6F4C5'
export const UI_COLOR_DANGER = '#CB2128'
// Stronger danger tone used when a more critical negative contrast is needed.
export const UI_COLOR_DANGER_ALT = '#FF0C3E'
export const UI_COLOR_DANGER_TEXT = '#CB2128'
export const UI_COLOR_DANGER_SOFT = '#FDEBEC'
export const UI_COLOR_DANGER_BADGE_BG = '#FDEBEC'
export const UI_COLOR_DANGER_BADGE_TEXT = '#CB2128'
export const UI_COLOR_DANGER_BORDER = '#F5A3A3'
export const UI_COLOR_DANGER_SOFT_HOVER = '#FAD8D8'
export const UI_COLOR_ERROR = UI_COLOR_DANGER
export const UI_COLOR_WARNING_TEXT = '#B26A00'
export const UI_COLOR_WARNING_SOFT = '#FFF4E2'
// Police payment deduction card colors.
export const UI_COLOR_POLICE_PAYMENT_BG = '#FFF9F9'
export const UI_COLOR_POLICE_PAYMENT_BORDER = '#FFC9C9'
export const UI_COLOR_POLICE_PAYMENT_ACCENT = '#FF3C64'

// Palette shown in the reference sheets.
export const UI_COLOR_BADGE_INFO_BG = '#E7ECF6'
export const UI_COLOR_BADGE_INFO_TEXT = '#27588D'
export const UI_COLOR_BADGE_SUCCESS_BG = '#EAF6EB'
export const UI_COLOR_BADGE_SUCCESS_TEXT = '#2E7D32'
export const UI_COLOR_BADGE_WARNING_BG = '#FFF4E2'
export const UI_COLOR_BADGE_WARNING_TEXT = '#B26A00'
export const UI_COLOR_STATUS_ACTIVE_BG = UI_COLOR_BADGE_SUCCESS_BG
export const UI_COLOR_STATUS_ACTIVE_TEXT = UI_COLOR_BADGE_SUCCESS_TEXT
export const UI_COLOR_STATUS_INACTIVE_BG = UI_COLOR_DANGER_BADGE_BG
export const UI_COLOR_STATUS_INACTIVE_TEXT = UI_COLOR_DANGER_BADGE_TEXT
export const UI_COLOR_STATUS_PENDING_BG = UI_COLOR_BADGE_WARNING_BG
export const UI_COLOR_STATUS_PENDING_TEXT = UI_COLOR_BADGE_WARNING_TEXT
export const UI_COLOR_STATUS_REVIEW_BG = '#E7ECF6'
export const UI_COLOR_STATUS_REVIEW_TEXT = '#27588D'
export const UI_COLOR_STATUS_NOT_STARTED_BG = '#FFF1E6'
export const UI_COLOR_STATUS_NOT_STARTED_TEXT = '#E6752E'
export const UI_COLOR_STATUS_EXPIRED_BG = '#F5F5F5'
export const UI_COLOR_STATUS_EXPIRED_TEXT = '#505050'
export const UI_COLOR_STATUS_SUSPENDED_BG = UI_COLOR_DANGER_BADGE_BG
export const UI_COLOR_STATUS_SUSPENDED_TEXT = UI_COLOR_DANGER_BADGE_TEXT
export const UI_COLOR_STATUS_COMPLETED_BG = '#E8F5E9'
export const UI_COLOR_STATUS_COMPLETED_TEXT = '#1B5E20'
export const UI_COLOR_RBAC_ROLE_BG = '#EDE9F6'
export const UI_COLOR_RBAC_ROLE_TEXT = '#5E43A6'
export const UI_COLOR_RBAC_ROLE_UNASSIGNED_BG = '#EEEEEE'
export const UI_COLOR_RBAC_ROLE_UNASSIGNED_TEXT = '#616161'
export const UI_COLOR_RBAC_ROLE_GERENCIA_BG = '#FCE4EC'
export const UI_COLOR_RBAC_ROLE_GERENCIA_TEXT = '#880E4F'
export const UI_COLOR_RBAC_ROLE_SUPERVISOR_BG = '#E3F2FD'
export const UI_COLOR_RBAC_ROLE_SUPERVISOR_TEXT = '#1565C0'
export const UI_COLOR_RBAC_ROLE_PROCESADOR_BG = '#E8EAF6'
export const UI_COLOR_RBAC_ROLE_PROCESADOR_TEXT = '#283593'
export const UI_COLOR_RBAC_ROLE_COORDINADOR_BG = '#E0F7FA'
export const UI_COLOR_RBAC_ROLE_COORDINADOR_TEXT = '#00695C'
export const UI_COLOR_RBAC_ROLE_AUDITOR_BG = '#E0F2F1'
export const UI_COLOR_RBAC_ROLE_AUDITOR_TEXT = '#004D40'

// Grey scale tokens ordered from lightest to darkest for consistency.
export const UI_COLOR_SURFACE = UI_COLOR_WHITE
export const UI_COLOR_SURFACE_50 = '#F5F7F9'
export const UI_COLOR_SURFACE_100 = '#F0F0F0'
export const UI_COLOR_SURFACE_300 = '#E0E0E0'
export const UI_COLOR_SURFACE_400 = '#BDBDBD'
export const UI_COLOR_SURFACE_500 = '#9A9A9A'
export const UI_COLOR_SURFACE_600 = '#757575'
export const UI_COLOR_SURFACE_700 = '#505050'
export const UI_COLOR_SURFACE_800 = '#3D3D3D'
export const UI_COLOR_SURFACE_900 = '#262626'

// Text colors by hierarchy and readability context.
export const UI_COLOR_TEXT_HEADING = '#111827'
export const UI_COLOR_TEXT_BRAND_DARK = '#162B5B'
export const UI_COLOR_TEXT_NAVY = '#213861'
export const UI_COLOR_TEXT_PRIMARY = '#202020'
export const UI_COLOR_TEXT_DARK = '#212121'
export const UI_COLOR_TEXT_NEUTRAL = '#4B5563'
export const UI_COLOR_TEXT_GRAY = '#828282'
export const UI_COLOR_TEXT_INFO = '#35516F'
export const UI_COLOR_TEXT_ICON_MUTED = '#595959'
export const UI_COLOR_TEXT_STRONG = '#223042'
export const UI_COLOR_TEXT_STRONG_ALT = '#203145'
export const UI_COLOR_TEXT_TITLE = '#40566F'
export const UI_COLOR_TEXT_TITLE_ALT = '#5F6B7A'
export const UI_COLOR_TEXT_SUBTITLE = '#6B7280'
export const UI_COLOR_TEXT_SECONDARY = '#606060'
export const UI_COLOR_TEXT_MUTED = '#5F6F82'
export const UI_COLOR_TEXT_SUBTLE = '#6E879C'
export const UI_COLOR_TEXT_PLACEHOLDER = '#8C98A8'
export const UI_COLOR_TEXT_BODY = '#334155'
export const UI_COLOR_TEXT_DISABLED = '#B8C2CC'
export const UI_COLOR_TEXT_DISABLED_DARK = UI_COLOR_SURFACE_500
export const UI_COLOR_TEXT_READONLY = '#A0A0A0'
export const UI_COLOR_TEXT_TERTIARY = '#8E909B'
export const UI_COLOR_TEXT_MUTED_LIGHT = '#9CA3AF'
export const UI_COLOR_TEXT_SURVEY_HEADING = '#222222'
export const UI_COLOR_TEXT_SURVEY_BODY = '#2F2F2F'
export const UI_COLOR_TEXT_SURVEY_CHIP = '#333333'
export const UI_COLOR_TEXT_SURVEY_ICON = UI_COLOR_SURFACE_600
export const UI_COLOR_TEXT_SURVEY_PLACEHOLDER = '#9E9E9E'
export const UI_COLOR_TEXT_SURVEY_MENU = '#374151'
export const UI_COLOR_TEXT_SURVEY_SELECTOR = '#5F6368'
export const UI_COLOR_TEXT_SURVEY_CONDITIONAL = '#C2410C'
export const UI_COLOR_TEXT_SURVEY_CONDITIONAL_ALT = '#EA580C'
export const UI_COLOR_TEXT_SURVEY_CONDITIONAL_DARK = '#9A3412'
export const UI_COLOR_TEXT_SURVEY_CONDITIONAL_CHIP = '#27588D'
// Muted icon chrome shared by headers and detail cards.
export const UI_COLOR_TEXT_ICON = '#515465'
// Section titles in detail/approval views.
export const UI_COLOR_TEXT_SECTION = '#34445B'
export const UI_COLOR_TEXT_SECTION_MUTED = '#7A8797'
export const UI_COLOR_TEXT_SUMMARY_LABEL = '#31445B'
export const UI_COLOR_TEXT_SUMMARY_STRONG = '#162B45'
export const UI_COLOR_TEXT_CARD_TITLE = '#2F3640'
export const UI_COLOR_TEXT_BODY_DARK = '#1F2937'
export const UI_COLOR_TEXT_WARM = '#4D4845'
export const UI_COLOR_TEXT_INK = '#303238'
export const UI_COLOR_TEXT_INK_ALT = '#2D2F33'
export const UI_COLOR_TEXT_DIALOG_LABEL = '#686A6E'
export const UI_COLOR_TEXT_DIALOG_VALUE = '#626468'
export const UI_COLOR_TEXT_FILTER_LABEL = '#5F6673'
export const UI_COLOR_TEXT_HINT = '#8B8F9A'
export const UI_COLOR_TEXT_MUTED_ALT = '#9AA1AB'
export const UI_COLOR_TEXT_CANCEL = '#777777'
export const UI_COLOR_ICON_GRAY = '#666666'
export const UI_COLOR_TEXT_CARD_BODY = '#374151'
export const UI_COLOR_TEXT_CODE = '#2D5F95'

// Borders for cards, inputs, buttons, and disabled states.
export const UI_COLOR_BORDER_MEDIUM = '#E4E4E4'
export const UI_COLOR_BORDER_CARD = '#D7DEE8'
export const UI_COLOR_BORDER_SOFT = '#D8E0EA'
export const UI_COLOR_BORDER_SUBTLE = '#DADDE3'
export const UI_COLOR_BORDER_LIGHT = '#E2E8F0'
export const UI_COLOR_BORDER_TABLE = '#E5E7EB'
export const UI_COLOR_BORDER_DIVIDER = '#707070'
export const UI_COLOR_BORDER_NEUTRAL = '#D2D2D2'
export const UI_COLOR_BORDER_NEUTRAL_MEDIUM = '#C8C8C8'
export const UI_COLOR_BORDER_NEUTRAL_DARK = '#969696'
export const UI_COLOR_BORDER_INPUT = '#D7DCE3'
export const UI_COLOR_BORDER_INPUT_HOVER = '#C6CED8'
export const UI_COLOR_BORDER_INPUT_FOCUS = '#AEB9C7'
export const UI_COLOR_BORDER_DISABLED = '#E9EEF5'
export const UI_COLOR_BORDER_BUTTON = '#C9D5E3'
export const UI_COLOR_BORDER_BUTTON_HOVER = '#B8C8D8'
export const UI_COLOR_BORDER_SURVEY_MUTED = '#D9D9D9'
export const UI_COLOR_BORDER_SURVEY_INPUT = '#C9C9C9'
export const UI_COLOR_BORDER_SURVEY_INPUT_HOVER = UI_COLOR_SURFACE_400
export const UI_COLOR_BORDER_SURVEY_DROPZONE = '#D1D5DB'
export const UI_COLOR_BORDER_SURVEY_SELECTOR = '#D0D5DD'
export const UI_COLOR_BORDER_SURVEY_CONDITIONAL = '#FDBA74'
export const UI_COLOR_BORDER_SURVEY_CONDITIONAL_ALPHA = 'rgba(249, 115, 22, 0.35)'
export const UI_COLOR_BORDER_HAIRLINE = '#ECEDEF'
export const UI_COLOR_BORDER_FAINT = '#EEF0F3'
export const UI_COLOR_BORDER_CANCEL = '#9E9E9E'
export const UI_COLOR_BORDER_INFO_SOFT = '#BFD4FF'
export const UI_COLOR_BORDER_MUTED = '#E5E7EB'
export const UI_COLOR_BORDER_DIVIDER_SOFT = '#E5E5E5'
export const UI_COLOR_BORDER_CARD_NEUTRAL = '#E0E0E0'
export const UI_COLOR_BORDER_METRIC = '#D6DCE5'
export const UI_COLOR_PROGRESS_TRACK = '#D8E2EF'
export const UI_COLOR_BORDER_UTILITY = '#C8CCD2'
export const UI_COLOR_BORDER_UTILITY_HOVER = '#AEB7C2'
export const UI_COLOR_BORDER_UTILITY_DISABLED = '#E1E5EA'
export const UI_COLOR_BORDER_UTILITY_MOBILE = '#B8B8B8'

// Background and surface tones for cards, hovers, and readonly areas.
export const UI_COLOR_SURFACE_SOFT = '#F3F6F9'
export const UI_COLOR_SURFACE_MUTED = '#F8F7F7'
export const UI_COLOR_SURFACE_HOVER = '#F7F9FB'
export const UI_COLOR_SURFACE_DISABLED = '#F8FAFC'
export const UI_COLOR_SURFACE_TINT = '#FFFDFC'
export const UI_COLOR_SURFACE_INFO = '#F8FBFF'
export const UI_COLOR_SURFACE_READONLY = UI_COLOR_SURFACE_100
export const UI_COLOR_SURFACE_PRIMARY_SOFT = '#EEF5FB'
export const UI_COLOR_SURFACE_TABLE_STRIPE = '#F7F7F7'
export const UI_COLOR_SURFACE_TABLE_ACTIVE = '#F3F4F6'
export const UI_COLOR_SURFACE_TABLE_CHILD = '#FAFAFA'
export const UI_COLOR_SURFACE_TABLE_SUBTOTAL = '#F9FAFB'
export const UI_COLOR_SURFACE_TABLE_TOTAL = '#F5F5F5'
export const UI_COLOR_SURFACE_TABLE_HEADER = '#A29E9D'
export const UI_COLOR_SURFACE_SURVEY_CHIP = UI_COLOR_SURFACE_300
export const UI_COLOR_SURFACE_SURVEY_CONDITIONAL = '#FFEDD5'
export const UI_COLOR_SURFACE_SURVEY_CONDITIONAL_LIGHT = '#FFF3E0'
export const UI_COLOR_SURFACE_SURVEY_CONDITIONAL_SOFT = '#FFF7ED'
export const UI_COLOR_SURFACE_SURVEY_CONDITIONAL_CHIP = '#DBEAFE'
export const UI_COLOR_SURFACE_NEUTRAL = '#F5F6F8'
export const UI_COLOR_SURFACE_GHOST = '#F9FAFB'
export const UI_COLOR_SURFACE_SCAN_DARK = '#141414'
export const UI_COLOR_SURFACE_SUCCESS_ROW = '#FAFFF4'
export const UI_COLOR_SURFACE_SUCCESS_ROW_ALT = '#F4FCEB'
export const UI_COLOR_SURFACE_DISABLED_BTN = '#D7D8DB'
// Flat disabled control fill/border for dual-action and similar buttons.
export const UI_COLOR_SURFACE_DISABLED_FLAT = '#E9E9E9'
export const UI_COLOR_TEXT_DISABLED_FLAT = '#A6A6A6'
export const UI_COLOR_TEXT_UTILITY = '#8A8F98'
export const UI_COLOR_TEXT_UTILITY_HOVER = '#6F7782'
export const UI_COLOR_TEXT_UTILITY_DISABLED = '#B5BBC4'
export const UI_COLOR_TEXT_UTILITY_MOBILE = '#9B9797'
export const UI_COLOR_TEXT_UTILITY_MOBILE_HOVER = '#7B7777'
export const UI_COLOR_TEXT_OVERLINE = '#5E6B7A'
export const UI_COLOR_TEXT_SLATE = '#94A3B8'
export const UI_COLOR_TEXT_SLATE_ALT = '#64748B'
export const UI_COLOR_SURFACE_UTILITY_HOVER = '#F7F8FA'

// Soft elevation shadows shared by cards and action buttons.
export const UI_COLOR_SHADOW_SOFT = '0 2px 5px rgba(15, 23, 42, 0.12)'
export const UI_COLOR_SHADOW_BUTTON = '0 2px 4px rgba(15, 23, 42, 0.18)'
export const UI_COLOR_SHADOW_CARD = '0 4px 14px rgba(15, 23, 42, 0.16)'
export const UI_COLOR_SHADOW_PRIMARY_ACTION = '0 3px 7px rgba(15, 23, 42, 0.28)'
export const UI_COLOR_SHADOW_UTILITY_ACTION = '0 2px 5px rgba(0, 0, 0, 0.35)'
export const UI_COLOR_SHADOW_DANGER_ACTION = '0 1px 4px rgba(255, 77, 79, 0.25)'
export const UI_COLOR_OVERLAY_DARK = 'rgba(0, 0, 0, .8)'

// Softer primary used for secondary actions and calendar icons.
export const UI_COLOR_PRIMARY_SOFT_ALT = '#5D83B1'
export const UI_COLOR_PRIMARY_PRESS = '#3F6084'
export const UI_COLOR_PRIMARY_PRESS_ALT = '#446788'
export const UI_COLOR_PRIMARY_SOFT_FAINT = 'rgba(89, 127, 169, 0.04)'

// Calendar / active date accent (distinct from brand orange CTAs).
export const UI_COLOR_ACCENT_AMBER = '#F97316'
export const UI_COLOR_ACCENT_ORANGE_ACTION = '#FF7A30'
export const UI_COLOR_ACCENT_ORANGE_ACTION_HOVER = '#F06F28'
export const UI_COLOR_ACCENT_ORANGE_SOFT_HOVER = '#FFF4E5'
export const UI_COLOR_CHIP_INFO_BG = '#DCEEFF'
export const UI_COLOR_CHIP_INFO_TEXT = '#2D6E9F'
export const UI_COLOR_CHIP_ACCENT_BG = '#EDE9F6'
export const UI_COLOR_CHIP_ACCENT_TEXT = '#5E43A6'
export const UI_COLOR_CHIP_ASSIGNMENT_BG = '#E4F4FB'
export const UI_COLOR_CHIP_ASSIGNMENT_TEXT = '#0C9ADE'
export const UI_COLOR_BUTTON_MUTED = '#A29E9D'
export const UI_COLOR_BUTTON_MUTED_TEXT = '#7B7780'

// RBAC management table colors.
export const UI_COLOR_RBAC_TABLE_HEADER_BG = '#EAF1F8'
export const UI_COLOR_RBAC_TABLE_BORDER = '#D7E3EE'
export const UI_COLOR_RBAC_TABLE_ACCENT = '#27588D'
export const UI_COLOR_RBAC_STATUS_ACTIVE_BG = '#EAF6EB'
export const UI_COLOR_RBAC_STATUS_ACTIVE_TEXT = '#2E7D32'
export const UI_COLOR_RBAC_STATUS_INACTIVE_BG = '#FDEBEC'
export const UI_COLOR_RBAC_STATUS_INACTIVE_TEXT = '#CB2128'
export const UI_COLOR_RBAC_STATUS_PENDING_BG = '#FFF4E5'
export const UI_COLOR_RBAC_STATUS_PENDING_TEXT = '#B26A00'

// Success emphasis for alerts and confirmation banners.
export const UI_COLOR_SUCCESS_EMPHASIS = '#2F7D3C'
export const UI_COLOR_SUCCESS_EMPHASIS_BG = '#EEFBEF'
export const UI_COLOR_SUCCESS_EMPHASIS_TEXT = '#214F2A'

// Strong danger accents for reject actions and validation states.
export const UI_COLOR_DANGER_ACTION = '#E12B2F'
export const UI_COLOR_DANGER_ACTION_HOVER = '#C91F27'
export const UI_COLOR_DANGER_OUTLINE = '#FF4D4F'
export const UI_COLOR_DANGER_DEEP = '#DC2626'
// Negative amounts in totals / financial summaries (Material red 800).
export const UI_COLOR_DANGER_NEGATIVE = '#C62828'
export const UI_COLOR_DANGER_SURFACE = '#FFF5F5'

export const SURVEY_COLORS = {
  white: UI_COLOR_WHITE,
  blackAlpha12: UI_COLOR_BLACK_ALPHA_12,
  blackAlpha26: UI_COLOR_BLACK_ALPHA_26,
  blackAlpha40: UI_COLOR_BLACK_ALPHA_40,
  transparent: UI_COLOR_TRANSPARENT,
  primary: UI_COLOR_PRIMARY,
  accentOrange: UI_COLOR_ACCENT_ORANGE,
  error: UI_COLOR_ERROR,
  textHeading: UI_COLOR_TEXT_HEADING,
  textNeutral: UI_COLOR_TEXT_NEUTRAL,
  textMutedLight: UI_COLOR_TEXT_MUTED_LIGHT,
  textDisabledDark: UI_COLOR_TEXT_DISABLED_DARK,
  textSurveyHeading: UI_COLOR_TEXT_SURVEY_HEADING,
  textSurveyBody: UI_COLOR_TEXT_SURVEY_BODY,
  textSurveyChip: UI_COLOR_TEXT_SURVEY_CHIP,
  textSurveyIcon: UI_COLOR_TEXT_SURVEY_ICON,
  textSurveyPlaceholder: UI_COLOR_TEXT_SURVEY_PLACEHOLDER,
  textSurveyMenu: UI_COLOR_TEXT_SURVEY_MENU,
  textSurveySelector: UI_COLOR_TEXT_SURVEY_SELECTOR,
  textSurveyConditional: UI_COLOR_TEXT_SURVEY_CONDITIONAL,
  textSurveyConditionalAlt: UI_COLOR_TEXT_SURVEY_CONDITIONAL_ALT,
  textSurveyConditionalDark: UI_COLOR_TEXT_SURVEY_CONDITIONAL_DARK,
  textSurveyConditionalChip: UI_COLOR_TEXT_SURVEY_CONDITIONAL_CHIP,
  borderTable: UI_COLOR_BORDER_TABLE,
  borderSurveyMuted: UI_COLOR_BORDER_SURVEY_MUTED,
  borderSurveyInput: UI_COLOR_BORDER_SURVEY_INPUT,
  borderSurveyInputHover: UI_COLOR_BORDER_SURVEY_INPUT_HOVER,
  borderSurveyDropzone: UI_COLOR_BORDER_SURVEY_DROPZONE,
  borderSurveySelector: UI_COLOR_BORDER_SURVEY_SELECTOR,
  borderSurveyConditional: UI_COLOR_BORDER_SURVEY_CONDITIONAL,
  borderSurveyConditionalAlpha: UI_COLOR_BORDER_SURVEY_CONDITIONAL_ALPHA,
  surfaceReadonly: UI_COLOR_SURFACE_READONLY,
  surfaceTableActive: UI_COLOR_SURFACE_TABLE_ACTIVE,
  surfaceTableSubtotal: UI_COLOR_SURFACE_TABLE_SUBTOTAL,
  surfaceTableTotal: UI_COLOR_SURFACE_TABLE_TOTAL,
  surfaceSurveyChip: UI_COLOR_SURFACE_SURVEY_CHIP,
  surfaceSurveyConditional: UI_COLOR_SURFACE_SURVEY_CONDITIONAL,
  surfaceSurveyConditionalLight: UI_COLOR_SURFACE_SURVEY_CONDITIONAL_LIGHT,
  surfaceSurveyConditionalSoft: UI_COLOR_SURFACE_SURVEY_CONDITIONAL_SOFT,
  surfaceSurveyConditionalChip: UI_COLOR_SURFACE_SURVEY_CONDITIONAL_CHIP
}

// User status colors for active/inactive states in user management and profile sections.
export const USER_HEADER_COLORS = {
  title: UI_COLOR_PRIMARY_ALT,
  statusActiveBg: '#DFF5EA',
  statusInactiveBg: '#E5E7EB',
  statusActiveText: '#0A7A3D',
  statusInactiveText: UI_COLOR_TEXT_ICON
}

// User geofence modal colors for cancel and confirm buttons in the geofence management interface.
export const USER_GEOFENCE_MODAL_COLORS = {
  cancelBorder: '#B0A9A4',
  cancelText: '#9D9691',
  cancelHoverBackground: '#FFFFFF',
  cancelDisabledBorder: '#D1CBC7',
  cancelDisabledText: '#BDB6B1',
  confirm: '#50739A',
  confirmDisabledBorder: '#E5E7EB',
  confirmDisabledText: '#A8ACB6',
  confirmDisabledBackground: '#ECEEF2'
}


// Dialog chrome, titles, and supporting copy used by Confirm and RBAC modals.
export const UI_COLOR_TEXT_DIALOG_TITLE = '#1A2733'
export const UI_COLOR_TEXT_DIALOG_SUBTITLE = '#6B7A8C'
export const UI_COLOR_TEXT_DIALOG_META = '#5B6472'
export const UI_COLOR_TEXT_DIALOG_BODY = '#4A5160'
export const UI_COLOR_TEXT_DIALOG_FIELD_LABEL = '#3F415F'
export const UI_COLOR_TEXT_TABLE_MUTED = '#5B6B7A'
export const UI_COLOR_ICON_CHEVRON = '#98A2B3'
export const UI_COLOR_BORDER_DIALOG_DIVIDER = '#afa9a9'
export const UI_COLOR_BORDER_FORM_CARD = '#E7EDF3'
export const UI_COLOR_BORDER_INPUT_HOVER_ALT = '#AFAFAF'
export const UI_COLOR_AVATAR_NEUTRAL_BG = '#D9DEE5'
export const UI_COLOR_ROW_SELECTED_SOFT = '#FFF9F5'
export const UI_COLOR_SECTION_ICON_BG = '#EEF6FF'
export const UI_COLOR_ERROR_MATERIAL = '#D32F2F'
export const UI_COLOR_ERROR_MATERIAL_BG = '#FDEDED'
export const UI_COLOR_WARNING_ACCENT = '#C4611C'
export const UI_COLOR_DIVIDER_SOFT_ALT = '#00000067'
export const UI_COLOR_SHADOW_DIALOG = '0 16px 40px rgba(26, 39, 51, 0.16)'
export const UI_COLOR_SHADOW_DETAIL_CARD =
  '0 1px 3px 0 rgba(0, 0, 0, 0.07), 0 1px 2px 0 rgba(0, 0, 0, 0.05)'

// Role wizard and permission panel surfaces.
export const UI_COLOR_BORDER_PERMISSION = '#d8d8d8'
export const UI_COLOR_BORDER_PERMISSION_ALT = '#cfcfcf'
export const UI_COLOR_BORDER_PERMISSION_ROW = '#e1e1e1'
export const UI_COLOR_SURFACE_PERMISSION_SOFT = '#fbfcfd'
export const UI_COLOR_TEXT_PERMISSION_TITLE = '#242424'
export const UI_COLOR_BADGE_SPECIAL_BG = '#e7f2ff'
export const UI_COLOR_BADGE_SPECIAL_TEXT = '#376fa6'
export const UI_COLOR_TEXT_PRESET = '#43425d'
export const UI_COLOR_ICON_HELP = '#536176'
export const UI_COLOR_ICON_HELP_ACCENT = '#2f69a6'
export const UI_COLOR_TEXT_WIZARD_FIELD = '#4d4f5c'
export const UI_COLOR_BORDER_WIZARD_FIELD = '#c7c7c7'
export const UI_COLOR_BORDER_WIZARD_FIELD_HOVER = '#aeb3ba'
export const UI_COLOR_TEXT_WIZARD_PLACEHOLDER = '#6d6d6d'
export const UI_COLOR_TEXT_WIZARD_HINT = '#a7a7a7'
export const UI_COLOR_WIZARD_ERROR = '#f04438'
export const UI_COLOR_STEPPER_MUTED = '#d8dde2'
export const UI_COLOR_STEPPER_LABEL = '#8f96a3'
export const UI_COLOR_SHADOW_PERMISSION_CONTROL = '0 1px 3px rgba(15, 23, 42, 0.05)'
export const UI_COLOR_WIZARD_BAR_BG = '#f0f4f7'
export const UI_COLOR_WIZARD_PRESET_BORDER = '#d0d3d8'
export const UI_COLOR_WIZARD_PRESET_TEXT = '#555a61'
export const UI_COLOR_WIZARD_PRESET_READ_ACCENT = '#0c9ade'
export const UI_COLOR_WIZARD_PRESET_READ_BG = '#e4f4fb'
export const UI_COLOR_WIZARD_PRESET_READ_BG_HOVER = '#d8effa'
export const UI_COLOR_WIZARD_PRESET_WRITE_BG_HOVER = '#dff1e1'
export const UI_COLOR_WIZARD_PRESET_OFF_BG = '#fdece0'
export const UI_COLOR_WIZARD_PRESET_OFF_BG_HOVER = '#fbe1cf'
export const UI_COLOR_WIZARD_PRESET_NEUTRAL = '#6b7077'
export const UI_COLOR_WIZARD_PRESET_NEUTRAL_BG = '#f4f5f6'
export const UI_COLOR_WIZARD_PRESET_NEUTRAL_BG_HOVER = '#eef0f2'
export const UI_COLOR_WIZARD_PRESET_HOVER_BORDER = '#b9bec6'
export const UI_COLOR_WIZARD_PRESET_HOVER_TEXT = '#41464d'
export const UI_COLOR_SHADOW_WIZARD_BAR = '0 2px 6px rgb(15 23 42 / 8%)'
export const UI_COLOR_SHADOW_WIZARD_PRESET = '0 2px 5px rgb(15 23 42 / 5%)'
export const UI_COLOR_SHADOW_WIZARD_PRESET_HOVER = '0 3px 7px rgb(15 23 42 / 7%)'

// Audit history text, chips, and expanded panels.
export const UI_COLOR_AUDIT_LINK = '#0061FE'
export const UI_COLOR_AUDIT_PANEL_BG = '#FAFBFC'
export const UI_COLOR_AUDIT_SYSTEM_BG = '#EDEFF3'
export const UI_COLOR_AUDIT_CHIP_BG = '#f4f4f5'
export const UI_COLOR_TEXT_AUDIT_PRIMARY = 'rgba(0,0,0,0.87)'
export const UI_COLOR_TEXT_AUDIT_MUTED = 'rgba(0,0,0,0.6)'
export const UI_COLOR_TEXT_AUDIT_SECONDARY = 'rgba(0,0,0,0.55)'
export const UI_COLOR_TEXT_AUDIT_FAINT = 'rgba(0,0,0,0.4)'
export const UI_COLOR_AUDIT_STRIKE = 'rgba(0,0,0,0.25)'
export const UI_COLOR_AUDIT_STRIKE_CHIP = 'rgba(0, 0, 0, 0.35)'
export const UI_COLOR_SKELETON_BAR = 'rgba(0, 0, 0, 0.08)'

// Form header action buttons (mirrored in _ui_colors.scss).
export const UI_COLOR_GHOST_HOVER_BG = '#f1f4f8'
export const UI_COLOR_DANGER_HEADER = '#d64545'
export const UI_COLOR_SUCCESS_HEADER = '#4caf50'
export const UI_COLOR_PRIMARY_HEADER_HOVER = '#ff771f'
export const UI_COLOR_SECONDARY_HOVER_BG = '#f8f9fb'
export const UI_COLOR_SECONDARY_HOVER_BORDER = '#bcc3cd'
export const UI_COLOR_DANGER_HEADER_HOVER_BG = '#fbeaea'
export const UI_COLOR_SUCCESS_HEADER_HOVER_BG = '#edf7ed'
export const UI_COLOR_DISABLED_BTN_TEXT = '#c0c4cc'

// Palette for the report PDF template. Reuse shared colors where the values match.
export const REPORT_PDF_COLORS = {
  deep: UI_COLOR_SECONDARY_MAIN,
  title: '#1F4570',
  amount: UI_COLOR_SECONDARY_DARK,
  bar: UI_COLOR_SECONDARY_MID,
  orange: '#C9651F',
  danger: '#FF4343',
  dangerBg: UI_COLOR_DANGER_SOFT,
  dangerLine: '#F8D6D8',
  text: UI_COLOR_SURFACE_900,
  secondary: UI_COLOR_SURFACE_700,
  muted: UI_COLOR_SURFACE_600,
  label: '#33404E',
  stroke: '#DEE8F3',
  line: '#E3E9F0',
  panel: '#FBFCFE',
  head: '#E9EFF6',
  zebra: '#FAFBFD',
  track: '#EDF0F4',
  other: '#B9C3CF',
  white: UI_COLOR_WHITE
}

export const REPORT_DISTRIBUTION_PALETTE = [
  UI_COLOR_SECONDARY_MAIN,
  UI_COLOR_PRIMARY_DEFAULT,
  '#7FA3C9',
  UI_COLOR_PRIMARY_ALT,
  '#F5B98A',
  '#B7C7DA',
  '#94A6BE'
]
export const UI_COLOR_REPORT_DISTRIBUTION_EMPTY = '#D5DCE4'
